import React from 'react';

import { Box, xcss } from '@atlaskit/primitives';

const tableStyle = xcss({
	margin: 'space.0',
	width: '100%',
});

export const Table: React.FC<{ testId?: string; children?: React.ReactNode }> = ({
	children,
	testId,
	...props
}) => (
	<Box xcss={tableStyle} testId={testId} {...props} as="table">
		{children}
	</Box>
);
